import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import collect from 'collect.js';
import Overlay from "ol/Overlay";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { BehaviorSubject, Observable, Subject, Subscription, throwError } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { PublicLayers } from 'src/app/core/util/openDataModals';
import { ServiceErrorHandler } from 'src/app/decorator/service-error-handler-decorator';
import { AbstractService } from '../common/abstract.service';
@Injectable({
  providedIn: 'root'
})
export class MapService extends AbstractService {
  publicLayers=new EventEmitter();
  layers:Subscription;
  symobology: Subject<any> = new Subject<any>();
  panLocation: Subject<any> = new Subject<any>();
  locationAddress: Subject<any> = new Subject<any>();
  private dataSubject = new BehaviorSubject<any>(null);
  public data$ = this.dataSubject.asObservable();
  // get Data for rifht panel by Mujahid
  public mainLayers: any
  public mainLayerId: any
  vectorLayer: VectorLayer<any>;
  vectorSource: VectorSource;
  popupOverlay: Overlay;
  keyword: any
  searchFeature: any
  circleVectorSource: any
  closeOverlayPopup: Subject<any> = new Subject<any>();
  public markerPopup: Overlay
  public isArcgisErrorModalOpen = false;
  constructor(private http: HttpClient,) {
    super();
  }
  @ServiceErrorHandler()
  public getGeoJsonFeatures(sub_layer_id: number, sub_layer_name: string): Observable<any> {
    return this.http.get(`/api/layers?sub_layer_id=${sub_layer_id}&sub_layer_name=${sub_layer_name}&with=locations`, this.httpOptions);
  }
  @ServiceErrorHandler()
  public getBookmarks() {
    return this.http.get('/api/bookmark/locations', this.httpOptions);
  }
  public saveBookmarks(location) {
    return this.http.post('/api/bookmark/locations',location, this.httpOptions);
  }
  @ServiceErrorHandler()
  public arcGisStyle(id,platform,data) {
    return this.http.put(`/api/integrationconfigs/${id}?platform=${platform}`,data, this.httpOptions);
  }


  // get public layers
  @ServiceErrorHandler()
  public getOpenDataLayers(publicLayer) {
    if(publicLayer.type=='public_arcgis'){
      const formData=new FormData();
      formData.append('f','pjson');
      return this.http.post(`${publicLayer.url}`,formData);
    }
    let param;
    if(publicLayer.username){
      param = {
        url: publicLayer.url,
        username: publicLayer.username ? publicLayer.username : '',
        password: publicLayer.password ? publicLayer.password : ''
      }
    }else{
      param = {
        url: publicLayer.url,
      }
    }

    return this.http.post(`/layers/curl`,param,{responseType: 'text', headers: this.httpOptions.headers});
  }
  // get all public layer
  @ServiceErrorHandler()
  public getOpenData(type?: string): Observable<PublicLayers[]> {
    if (type) {
      return this.http.get<PublicLayers[]>(`/api/openlayers?type=${type}`, this.httpOptions);
    }
    return this.http.get<PublicLayers[]>(`/api/openlayers`, this.httpOptions)
    .pipe(
      shareReplay()
    );
  }

  @ServiceErrorHandler()
  getSavedGeoJsonLayers(): Observable<any> {
    return this.http.get('/api/custom-data-imports?type=geojson', this.httpOptions);
  }

  // save public layer
  @ServiceErrorHandler()
  public saveOpenData(data) {
    return this.http.post(`/api/openlayers`,data, this.httpOptions);
  }
  // save public layer
  @ServiceErrorHandler()
  public saveGeoJsonFile(data, headers) {
    return this.http.post(`/api/openlayers`,data, headers);
  }
  // update public layer
  @ServiceErrorHandler()
  public updateOpenData(data) {
    return this.http.put(`/api/openlayers/${data.id}`,data, this.httpOptions);
  }
  // delete public layer
  @ServiceErrorHandler()
  public deleteOpenData(id) {
    return this.http.delete(`/api/openlayers/${id}`, this.httpOptions);
  }
  // delete Custom Data layer
  @ServiceErrorHandler()
  public deleteCustomData(id) {
    return this.http.delete(`/api/custom-data-imports/${id}`, this.httpOptions);
  }
  //after layers maped
  public afterLayerMaped(action){
    this.publicLayers.emit(action);
  }
  //wms single feature get
  @ServiceErrorHandler()
  public getwmsFeaturesOnClick(url){
    return this.http.get(`${url}`,{responseType: 'text'});
  }
  //get layer symobology
  @ServiceErrorHandler()
  public getSymobology(url,id,integration_token=''){
    return this.http.get(`${url}/${id}/?f=json&token=${integration_token}`)
  }
  @ServiceErrorHandler()
  public getArcGisLayerExtent(url: string, layerId: number, token: string = '') {
    return this.http.get(
      `${url}/${layerId}/query?where=1%3D1&returnExtentOnly=true&f=json&token=${token}&outSR=3857`
    );
  }
  @ServiceErrorHandler()
  public getSymobologyArcGis(layer_id,id,integration_token=''){
    let responce = {};
    return this.http.get(`https://www.arcgis.com/sharing/rest/content/items/${id}/data?f=json&token=${integration_token}`)
    .pipe(
      map((res: any)=> {
        if(res){
          if(res.layers){
            if(res.layers[layer_id] || (res.layers[0] && res.layers[0].id === layer_id)){
              if(res.layers.length === 1) {
                responce = res.layers[0];
              } else {
                responce = res.layers[layer_id];
              }
            }
          }
        }
        return responce;
      }),
    );
  }
  @ServiceErrorHandler()
  public getSymobologyForSubprojects(url,id,integration_token=''){
    // return this.http.get(`${url}/${id}/?f=pjson&token=${integration_token}`)
    return this.http.get(`${url}/${id}/query?f=json&token=${integration_token}&where=1=1&outFields=*`)
  }
  // save public layer
  @ServiceErrorHandler()
  public potentialStakeholderBackendAPI(query, analysis?: boolean) {
    const url = analysis === true ? '/api/stakeholders/potential?potential-stakeholder-analysis=1' :
      '/api/stakeholders/potential'
    return this.http.post(url,query, this.httpOptions)
    .pipe(
      shareReplay()
    );
  }
  // save sorted open data
  @ServiceErrorHandler()
  public setSortedOpenData(data,type) {
    return this.http.post(`/api/${type}/sort`,data, this.httpOptions);
  }
  //set symobology
  public setSymobology(action){
    this.symobology.next(action);
  }

  setPanLocation(data) {
    this.panLocation.next(data)
  }
  getAddress(data) {
    this.locationAddress.next(data)
  }
  public setOverlayPopup(action){
    this.closeOverlayPopup.next(action);
  }

  setData(data: any) {
    this.dataSubject.next(data);
  }
  /*
    Layer Link Authentication
  */
  @ServiceErrorHandler()
  public setLayerAuthentication(publicLayer) {
    if(publicLayer.type=='public_arcgis'){
      const formData=new FormData();
      formData.append('f','pjson');
      return this.http.post(`${publicLayer.url}`,formData);
    }
    return this.http.post(`/api/layers/authenticate`,{url:publicLayer.url}, this.httpOptions);
  }
  @ServiceErrorHandler()
  public getPrivateFeatures(publicLayer, link) {
    let param;
    if(publicLayer.credentials && publicLayer.credentials.username){
      param = {
        url: link,
        username: publicLayer.credentials.username ? publicLayer.credentials.username : '',
        password: publicLayer.credentials.password ? publicLayer.credentials.password : ''
      }
    }else{
      param = {
        url: link,
      }
    }
    return this.http.post(`/layers/curl`, param, {responseType: 'text', headers: this.httpOptions.headers})
      .pipe(
        map((response: string) => {
          // Check if response is XML (error response) - GeoJSON is valid JSON and won't start with '<'
          if (response.trim().startsWith('<')) {
            // Extract error message from XML if possible
            const errorMatch = response.match(/<Exception[^>]*>([^<]+)/i) || response.match(/<ows:ExceptionText[^>]*>([^<]+)/i);
            const errorMsg = errorMatch ? errorMatch[1] : 'Unknown error';
            throw new Error(`WFS server returned XML error response: ${errorMsg}. The server may not support the requested output format.`);
          }
          // Try to parse as JSON
          try {
            return JSON.parse(response);
          } catch (e) {
            throw new Error(`Failed to parse WFS response as JSON: ${e.message}. Response: ${response.substring(0, 200)}...`);
          }
        })
      );
  }
  /*
    Get Integration Layers
  */
  @ServiceErrorHandler()
  public getIntegrationLayers(platform: string) {
    return this.http.get(`/api/getenabledlayers?platform=${platform}`, this.httpOptions);
  }
  /*
    Get Open Data Layers For Subproject
  */
  @ServiceErrorHandler()
  public getOpenDataEnableLayers() {
    return this.http.get(`/api/openlayers`, this.httpOptions)
    .pipe(
      map((res: any) => {
        if(res.length) {
          return collect(res).map((item: any) => {item.layers = collect(item.layers).where('is_enabled', true).all(); return item;}).all();
        }
        return res;
      })
    )
  }
  /*
    Get Integration Features From Layers
  */
  @ServiceErrorHandler()
  public getIntegrationFeaturesLayers(url, id, integration_token=''){
    return this.http.get(`${url}/${id}/query?f=json&token=${integration_token}&where=1=1&outFields=*`)
  }
  /*
    Get ArcGis Integration Sub Layers
  */
  @ServiceErrorHandler()
  public getArcGisSubLayers(url, integration_token=''){
    return this.http.get(`${url}?f=json&token=${integration_token}`)
    .pipe(
      switchMap((res: any) => {
        if (res?.error) {
          return throwError(() => ({ arcgisError: true, code: res.error.code, message: res.error.message }));
        }
        return [res.layers || []];
      })
    )
  }

  // get all dialog projects
  @ServiceErrorHandler()
  getAllDialogProjects(): Observable<any> {
    return this.http.get('/api/all-projects', this.httpOptions);
  }
}
